var CreateReactiveWO = /** @class */ (function () {
    function CreateReactiveWO() {
    }
    CreateReactiveWO.parse = function (json) {
        if (!json)
            return null;
        var wo = new CreateReactiveWO();
        Object.keys(json).forEach(function (key) {
            wo[key] = json[key];
        });
        return wo;
    };
    CreateReactiveWO.prototype.toEntity = function () {
        return {
            caller: this.callerName,
            CallerPositionId: this.positionId,
            serviceCodeId: this.serviceCodeId,
            problemDescription: this.problemDescription,
            AddtionalDetail: this.addtionalDetail,
            locationId: this.locationId,
            AccesccInformation: this.accessInformation,
            PriorityId: this.priorityId,
            Technician: this.technician,
            AffiliateId: this.affiliateId,
            TechnicianScheduleStartTime: this.technicianScheduleStartTime,
            TechnicianScheduleEndTime: this.technicianScheduleEndTime,
            WOTypeId: this.woTypeId
        };
    };
    return CreateReactiveWO;
}());
export default CreateReactiveWO;
